<template>
  <div class="d-flex align-items-center">
    <!-- near_me | explore -->
    <span class="material-icons md-18 me-2">explore</span>
    <div class="d-flex flex-wrap align-content-start">
      <div class="me-2">
        <span>{{ $i18n.t('latitude') }}: {{ lat }}&#176;</span>
      </div>
      <div>
        <span>{{ $i18n.t('longitude') }}: {{ lon }}&#176;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GpsField',
  props: {
    content: {
      type: String,
    },
  },
  computed: {
    hasValue() {
      return typeof this.content === 'string' && this.content.length
    },
    coordinates() {
      return this.hasValue ? this.content.split(';') : []
    },
    lat() {
      return this.coordinates[0]
    },
    lon() {
      return this.coordinates[1]
    },
  },
}
</script>
